import { useCallback } from 'react';
import { PerformanceTimer } from '../utils/perfomance';
import { useStoreValue } from '../../state/hooks/useStore';

export const useCreatePerformanceTimer = () => {
  const store = useStoreValue();
  return useCallback(
    (name: string, initialData?: Record<string, any>) =>
      PerformanceTimer.createAndStart(name, { ...initialData, store }),
    [store]
  );
};
